import React, { Fragment } from "react"
import PropTypes from "prop-types"

import styles from "./pageChannelReplay.css"
import TileVideo from "../../components/TileVideo/TileVideo"
import VideoGrid from "components/VideoGrid/VideoGrid"
import GridTitle from "components/GridTitle/GridTitle"
import PageActions from "components/PageActions/PageActions"
import { useOnCTAClick } from "helpers/CTA"

const PageChannelReplayView = ({ description, isReplay, sections }) => {
  const onClick = useOnCTAClick()

  return (
    <PageActions onClick={onClick}>
      <div className={styles.section}>
        {sections &&
          sections
            .filter(section => section.getItemsCount() > 0)
            .map(section => (
              <Fragment key={section.getSlug()}>
                <GridTitle>{section.getTitle()}</GridTitle>
                <VideoGrid>
                  {section
                    .getItems()
                    .slice(0, 18)
                    .map((program, index) => (
                      <TileVideo
                        // section={consts.slugs[section.getSlug()] ? consts.slugs[section.getSlug()] : section.getSlug()}
                        key={`${index}-${program.getId()}`}
                        isLive={section.isLive()}
                        useMicroData
                        displaySubtitle={section.shouldDisplaySubtitle()}
                        tile={program}
                        isReplay={isReplay}
                      />
                    ))}
                </VideoGrid>
              </Fragment>
            ))}
        {description && description.description ? (
          <div className={styles.channelDescription}>
            <h2 className={styles.subTitle}>{description.title}</h2>
            <div className={styles.descriptionContent} dangerouslySetInnerHTML={{ __html: description.description }} />
          </div>
        ) : null}
      </div>
    </PageActions>
  )
}

PageChannelReplayView.propTypes = {
  description: PropTypes.object,
  isReplay: PropTypes.bool,
  sections: PropTypes.array,
}

export default PageChannelReplayView
